export default __webpack_public_path__ + "static/media/chapter-background.3e048530.jpg";